export enum SeparatorSpacing {
    Default = "default",
    Small = "small",
    Medium = "medium",
    Large = "large",
}
